import { defaultSelectedServiceRequest } from "./state";
import shortid from "shortid";
import { dragDisable } from "d3";

export function setSellers(state, sellers) {
  state.sellers = sellers;
}
export function resetSellers(state, sellers) {
  state.sellers = [];
}
export function setContacts(state, contacts) {
  state.contacts = contacts;
}

export function setContactsWarehouse(state, contactsWarehouse) {
  state.contactsWarehouses = contactsWarehouse;
}
export function setProducts(state, products) {
  state.products = products;
}

export function setProductsLineBatteries(state, products) {
  state.productsLineBatteries = products;
}

export function setProductsLineBatteriesScrap(state, products) {
  state.productsLineBatteriesScrap = products;
}

export function setTypes(state, types) {
  state.types = types;
}

export function setReplacePhotographicEvidence(state, data) {
  state.params.photographic_evidences = data;
}
export function setRequestServiceApproveForm(state, data) {
  state.requestServiceApproveForm = data;
}

export function setIsActionUpdateStateView(state, value) {
  state.isActionUpdateStateView = value;
}

/**
 * Este metodo se encarga de resetear el formulario de registro.
 *
 * @author Kevin Galindo
 */
export function resetFormRequestService(state, types) {
  state.params = {
    observation: null,
    type: null,
    contact: null,
    seller: null,
    product: null,
    user: null,
    address: null
  };

  state.typePhotographicEvidence = [];
}

/**
 *
 * Este mutador se encarga de setear la informacion de la
 * tabla con su paginacion.
 *
 * @author Kevin Galindo
 */
export function setServiceRequests(state, data) {
  // Agregamos los datos de la tabla
  state.tableServiceRequests.data = data;

  // Quitamos los valores de la tabla del arreglo
  // delete data.data;

  // // Agregamos los datos de la paginacion
  // state.tableServiceRequests.pagination = data;
}

/**
 *
 * Este mutador de setear el
 * registro seleccionado para poder editar
 * o ver informacion sobre el
 *
 * @author Kevin Galindo
 */
export function setSelectedServiceRequest(state, item) {
  // Agregamos el registro
  state.selectedServiceRequest.data = item;
}

export function setErrorUpdateStatus(state, item) {
  state.errorUpdateStatus = item;
}
export function setResponseSelectedServiceRequest(state, item) {
  state.responseSelectedServiceRequest = item;
}
export function setPathsDocumentsStatus(state, item) {
  state.pathsDocumentsStatus = item;
}
export function setFinalizeUpdateState(state, item) {
  state.finalizeUpdateState = item;
}

export function setTypeImageCodesRequired(state, data) {
  state.typeImageCodesRequired = data;
}

export function setInvoicesContact(state, data) {
  state.invoicesContact = data;
}
export function setCreditNoteDocuments(state, data) {
  state.creditNoteDocuments = data;
}

export function setLoadingServiceRequests(state, value) {
  state.loadingServiceRequests = value;
}

/**
 *
 * Este mutador se encarga de organizar el
 * historico de los estados por registro
 *
 * @author Kevin Galindo
 */
export function setHistoryStateServiceRequest(state) {
  let actual_state = state.selectedServiceRequest.data.actual_state.state;
  let serviceRequest = state.selectedServiceRequest.data;
  let allStatesByType = serviceRequest.type.states;
  let completedStates = serviceRequest.status_history;
  let historyStates = [];
  let historyStatesReturn = [];

  // Validamos los estados que ya hayan sido finalizados
  allStatesByType.map((ast, astIndex) => {
    let stateExists = completedStates.find(cp => cp.state.id == ast.id);

    // Si existe el estado se agrega la informacion
    if (stateExists) {
      historyStates.push({
        service_requests_status_history_id: stateExists.id,
        id: stateExists.state.id,
        name: stateExists.state.name,
        date: stateExists.date,
        user: stateExists.user,
        observation: stateExists.observation,
        completed: true,
        service_requests_state_id: stateExists.state.service_requests_state_id,
        document: stateExists.document,
        path_file_document: stateExists.path_file_document,
        path_file_document_customer: stateExists.path_file_document_customer,
        path_file_document_reverse: stateExists.path_file_document_reverse
      });

      return;
    }

    // Si no existe se agrega sin info
    historyStates.push({
      id: ast.id,
      name: ast.name,
      date: "",
      user: "",
      observation: "",
      completed: false,
      service_requests_state_id: ast.service_requests_state_id
    });
  });

  // Quitamos los estados
  historyStates.map((hs, indexhs) => {
    if (hs.completed) {
      historyStatesReturn.push(hs);
      return;
    }
    let existSubState = historyStates.find(
      hhs => actual_state.id == hhs.service_requests_state_id
    );

    if (existSubState) {
      if (actual_state.id == hs.service_requests_state_id) {
        historyStatesReturn.push(hs);
      }
    } else {
      if (
        actual_state.service_requests_state_id == hs.service_requests_state_id
      ) {
        historyStatesReturn.push(hs);
      }
    }
  });

  //Organizamos la informacion
  historyStatesReturn.sort(function(a, b) {
    let keyA = a.id;
    let keyB = b.id;

    // Compare the 2 dates
    if (keyA < keyB) return -1;
    if (keyA > keyB) return 1;
    return 0;
  });

  // Agregamos la informacion
  state.selectedServiceRequest.historyStates = historyStatesReturn;
}

/**
 *
 * este metodo se encarga de finalizar
 * la actualizacion de un documento
 *
 * @author Kevin Galindo
 */
export function finalizeSelectedServiceRequest(state) {
  state.selectedServiceRequest.observation = "";
}

export function setResponseCreateRequest(state, data) {
  state.responseCreateRequest = data;
}

/**
 *
 * este metodo se encarga cambiar el estado del
 * loader del modal
 *
 * @author Kevin Galindo
 */
export function setStateLoaderSelectedServiceRequest(state, value) {
  state.selectedServiceRequest.loader = value;
}

/**
 *
 * este metodo se encarga cambiar el estado del
 * loader de la tabla
 *
 * @author Kevin Galindo
 */
export function setStateLoadertableServiceRequests(state, value) {
  state.tableServiceRequests.loader = value;
}

export function setDocument(state, id) {
  state.document = document;
}

export function setPDf(state, pdf) {
  state.fileName = pdf;
  state.showModalPdf = true;
}

export function setShowModalPdf(state, showModalPdf) {
  state.showModalPdf = showModalPdf;
}
export function setServiceRequestsStates(state, serviceRequestsStates) {
  state.serviceRequestsStates = serviceRequestsStates;
}

export function setDocumentActualState(state, data) {
  let serviceRequest = state.selectedServiceRequest.data;

  const { actual_state, document } = data;

  let stateUpdate = serviceRequest.status_history.find(
    hs => hs.state.id === actual_state.state.id
  );

  if (stateUpdate) {
    stateUpdate.document = document;
  }
}

export function setDefaulrSelectedServiceRequest(state, data) {
  Object.assign(state.selectedServiceRequest, defaultSelectedServiceRequest());
}

export function setdoccument_id(state, doccument_id) {
  state.doccument_id = doccument_id;
}

export function setTypePhotographicEvidence(state, data) {
  state.typePhotographicEvidence = data;
}

export function setPurchaseOptions(state, data) {
  state.purchaseOptions = data;
}

export function setListReasonsApprovals(state, data) {
  state.listReasonsApprovals = data;
}

export function setListReasonsRejection(state, data) {
  state.listReasonsRejection = data;
}

export function setProductsSublineScrap(state, data) {
  state.productsSublineScrap = data;
}

/*--- PhotographicEvidence CRUD ---*/
export function setPhotographicEvidence(state, data) {
  state.photographicEvidences = data;
}

export function addPhotographicEvidence(state, item) {
  const type = state.typePhotographicEvidence.find(
    t => t.value === item.type_image_id
  );

  const file = validateAndRenameFileDuplicate(state, item.document);

  state.photographicEvidences.push({
    ...item,
    document: file,
    document_name: file.name,
    id: shortid.generate(),
    type_image: {
      name_parameter: type.label,
      code_parameter: type.code
    }
  });
}

function validateAndRenameFileDuplicate(state, file) {
  let newFile = file;
  const fileNameFull = file.name;
  const fileName = fileNameFull
    .split(".")
    .slice(0, -1)
    .join(".");
  const fileType = file.type;
  const fileExtensions =
    fileNameFull.substring(
      fileNameFull.lastIndexOf("."),
      fileNameFull.length
    ) || fileNameFull;

  const exists = state.photographicEvidences.filter(
    p => p.document_name === fileNameFull
  );

  if (exists.length) {
    let notRepeated = false;

    let countRepeated = exists.length;
    const blob = file.slice(0, file.size, fileType);
    do {
      const fileNameNew = `${fileName}(${countRepeated})${fileExtensions}`;

      const existsNewFileName = state.photographicEvidences.filter(
        p => p.document_name === fileNameNew
      );

      if (existsNewFileName.length === 0) {
        newFile = new File([blob], fileNameNew, { type: fileType });
        notRepeated = true;
      }

      countRepeated++;
    } while (!notRepeated);
  }

  return newFile;
}

export function updatePhotographicEvidence(state, item) {
  const index = state.photographicEvidences.findIndex(p => p.id === item.id);

  if (index >= 0) {
    const type = state.typePhotographicEvidence.find(
      t => t.value === item.type_image_id
    );

    state.photographicEvidences.splice(index, 1, {
      ...item,
      document_name: item.document.name,
      type_image: {
        name_parameter: type.label,
        code_parameter: type.code
      }
    });
  }
}

export function deletePhotographicEvidence(state, item) {
  const index = state.photographicEvidences.findIndex(p => p.id === item.id);

  if (index >= 0) {
    state.photographicEvidences.splice(index, 1);
  }
}

/*--- rotationRefreshmentProducts CRUD ---*/
export function setTypesRotationRefreshmentProducts(state, data) {
  state.typesRotationRefreshmentProducts = data;
}

export function setRotationRefreshmentProducts(state, data) {
  state.rotationRefreshmentProducts = data;
}

export function addRotationRefreshmentProducts(state, item) {
  const type = state.typesRotationRefreshmentProducts.find(
    t => t.value === item.type_id
  );

  const product = state.products.find(t => t.id === item.product_id);

  state.rotationRefreshmentProducts.push({
    ...item,
    id: shortid.generate(),
    quantity: parseInt(item.quantity),
    product,
    type: {
      name_parameter: type.label
    }
  });
}

export function updateRotationRefreshmentProducts(state, item) {
  const index = state.rotationRefreshmentProducts.findIndex(
    p => p.id === item.id
  );

  if (index >= 0) {
    const type = state.typesRotationRefreshmentProducts.find(
      t => t.value === item.type_id
    );

    const product = state.products.find(t => t.id === item.product_id);

    state.rotationRefreshmentProducts.splice(index, 1, {
      ...item,
      product,
      type: {
        name_parameter: type.label
      }
    });
  }
}

export function deleteRotationRefreshmentProducts(state, item) {
  const index = state.rotationRefreshmentProducts.findIndex(
    p => p.id === item.id
  );

  if (index >= 0) {
    state.rotationRefreshmentProducts.splice(index, 1);
  }
}

export function setResponseUploadFilesRequest(state, response) {
  state.responseUploadFilesRequest = response;
}

export async function updatePhotographicEvidences(state, data) {
  await Promise.all(
    data.map(item => {
      const index = state.photographicEvidences.findIndex(
        p => p.document_name === item.name
      );
      const itemFound = state.photographicEvidences.find(
        p => p.document_name === item.name
      );

      if (index >= 0) {
        state.photographicEvidences.splice(index, 1, {
          ...itemFound,
          path_s3: item.path
        });
      }
    })
  );
}

export function setAction(state, value) {
  state.action = value;
}

export function setRequest(state, data) {
  state.params = data;
  state.sellers = [data.seller];
  state.contactsWarehouses = [data.contacts_warehouse];

  switch (data.service_requests_types_id) {
    case 1:
      state.params.product_id = data.products[0].product_id;
      state.products = data.products.map(({ product }) => product);
      state.photographicEvidences = data.photographic_evidences.map(item => ({
        ...item,
        document_name: item.name,
        path_s3: item.path
      }));
      break;
    case 5:
      state.rotationRefreshmentProducts = data.products;
      break;
    case 6:
      state.params.product_id = data.products[0].product_id;
      state.params.quantity = data.products[0].quantity;
      state.products = data.products.map(({ product }) => product);
      break;
  }
}

export function setCities(state, data) {
  state.cities = data;
}

export function setVehicleDataByPlate(state, data) {
  state.vehicleDataByPlate = data;
}

export function setCreateDocumentCurrentStateError(state, data) {
  state.createDocumentCurrentStateError = data;
}

/*--- ScrapReceptionProducts CRUD ---*/
export function setScrapReceptionProducts(state, data) {
  state.scrapReceptionProducts = data;
}

export function addScrapReceptionProducts(state, item) {
  const product = state.productsLineBatteriesScrap.find(
    t => t.id === item.product_id
  );

  state.scrapReceptionProducts.push({
    ...item,
    id: shortid.generate(),
    quantity: parseInt(item.quantity),
    product
  });
}

export function updateScrapReceptionProducts(state, item) {
  const index = state.scrapReceptionProducts.findIndex(p => p.id === item.id);

  if (index >= 0) {
    const product = state.productsLineBatteriesScrap.find(
      t => t.id === item.product_id
    );

    state.scrapReceptionProducts.splice(index, 1, {
      ...item,
      product
    });
  }
}

export function deleteScrapReceptionProducts(state, item) {
  const index = state.scrapReceptionProducts.findIndex(p => p.id === item.id);

  if (index >= 0) {
    state.scrapReceptionProducts.splice(index, 1);
  }
}

/*--- BatteryMaintenanceForm CRUD ---*/
export function setBatteryMaintenanceProducts(state, data) {
  state.batteryMaintenanceProducts = data;
}

export function addBatteryMaintenanceProducts(state, item) {
  const product = state.productsLineBatteries.find(
    t => t.id === item.product_id
  );

  state.batteryMaintenanceProducts.push({
    ...item,
    id: shortid.generate(),
    quantity: parseInt(item.quantity),
    product
  });
}

export function updateBatteryMaintenanceProducts(state, item) {
  const index = state.batteryMaintenanceProducts.findIndex(
    p => p.id === item.id
  );

  if (index >= 0) {
    const product = state.productsLineBatteries.find(
      t => t.id === item.product_id
    );

    state.batteryMaintenanceProducts.splice(index, 1, {
      ...item,
      product
    });
  }
}

export function deleteBatteryMaintenanceProducts(state, item) {
  const index = state.batteryMaintenanceProducts.findIndex(
    p => p.id === item.id
  );

  if (index >= 0) {
    state.batteryMaintenanceProducts.splice(index, 1);
  }
}

export function setSelectedMails(state, data) {
  state.selectedMails = data;
}

export function deleteLastItemSelectedMails(state, data) {
  state.selectedMails = state.selectedMails.pop();
}

export function setFetchData(state, value) {
  state.fetchData = value;
}



// WEBPACK FOOTER //
// ./src/modules/request-service/mutations.js